import { isNotAvailableImageValue } from './fieldValueCoercion';

/**
 * SKIN-726 — the web's "not available" mark on a visit-level shot (the NTD eCRF's
 * `healthy_skin_image`, "No healthy skin available"), with a mandatory reason.
 *
 * It is the app's SKIN-646 marker, `[{"type":"not_available"}]`, plus the reason. The
 * client writes only the reason; the API gates the write (close gate + DRAFT visit) and
 * stamps the actor (`by`) and the server clock (`at`), and never reads them from us.
 * The app's mark has no reason and keeps reading as the label alone.
 */

/**
 * The value the editor writes for a web mark. A JSON string, not an array: the API
 * only gates and stamps a mark that arrives as a string, and leaves an array alone.
 */
export function webNotAvailableMark(reason: string): string {
    const trimmed = reason.trim();
    if (trimmed === '') throw new Error('A "not available" mark needs a reason');
    return JSON.stringify([{ type: 'not_available', reason: trimmed }]);
}

/** The reason a web mark carries, trimmed; null for the app's mark, a blank reason, or anything else. */
export function notAvailableReason(value: unknown): string | null {
    if (!isNotAvailableImageValue(value)) return null;
    const [item] = typeof value === 'string' ? JSON.parse(value.trim()) : (value as any[]);
    const reason = typeof item?.reason === 'string' ? item.reason.trim() : '';
    return reason === '' ? null : reason;
}

/** "No healthy skin available (reason)" for a web mark; the label alone for the app's. */
export function notAvailableDisplay(label: string, reason: string | null): string {
    return reason ? `${label} (${reason})` : label;
}
